import axios from "axios";
import { AuthData, UnifyAccount } from "../types/types";
import { isDev } from "../utils";
import { attachSentryResponseInterceptor } from "./sentryAxiosInterceptor";

//Axios Instance

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_UNIFY_BASE_URL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    "X-Client-Origin": "ALLARIA",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const localAuth = localStorage.getItem("allaria-auth");

    const parsedLocalAuth: AuthData | null =
      (localAuth && JSON.parse(localAuth)) ?? null;

    const token = parsedLocalAuth?.access_token;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
attachSentryResponseInterceptor(axiosInstance);

export const getAllAssessmentAccounts = async ({
  email,
}: {
  email: string;
}) => {
  const response = await axiosInstance.post(
    isDev ? `/email/${email}/accounts/assessment` : `/accounts/assessment`
  );

  return response.data;
};

export const approveUnification = async ({
  email,
  accepted_tos,
  allaria_account_number,
  allaria_mas_account_id,
}: {
  email: string;
  allaria_account_number: string;
  allaria_mas_account_id?: string;
  accepted_tos: boolean;
}) => {
  const response = await axiosInstance.post(`/mirror`, {
    ...(isDev ? { email } : {}),
    allaria_account_number,
    allaria_mas_account_id,
    accepted_tos,
  });

  return response.data;
};

export const getUnifyAccount = async ({
  accountNumber,
}: {
  accountNumber: string;
}) => {
  const response = await axiosInstance.get(`/account/${accountNumber}`);
  return response.data as Promise<UnifyAccount>;
};

export const updateOnboardingInProcess = async ({
  allaria_account_number,
}: {
  allaria_account_number: string;
}) => {
  const response = await axiosInstance.post(`/callback`, {
    allaria_account_number,
    callback_type: "ONBOARDING_IN_PROCESS",
  });

  return response.data;
};
